export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_ncNo') || 'NC编号',
    field: 'ncNo',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_detailMaterialCategory') || '辅料类别',
    field: 'detailMaterialCategoryName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialSpec') || '规格',
    field: 'materialSpec',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialUnit') || '单位',
    field: 'v_materialUnit',
    align: 'center',
    width: 90,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unitPrice') || '单价',
    field: 'unitPrice',
    align: 'center',
    width: 90,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { unitPrice: value } = row
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_qty') || '耗料',
    field: 'qty',
    align: 'center',
    width: 90,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { qty: value } = row
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_subPrice') || '小计',
    field: 'subPrice',
    align: 'center',
    width: 90,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { subPrice: value } = row
      return that.format(value)
    },
  },
]
